(() => {
  const preserveQuery = (link) => {
    const current = new URL(window.location.href);
    const target = new URL(link.getAttribute('href'), current);
    const view = target.searchParams.get('view');
    target.search = current.search;
    target.searchParams.delete('page');
    target.searchParams.delete('section_id');
    target.searchParams.delete('sections');
    if (view && !target.searchParams.has('view')) target.searchParams.set('view', view);
    target.hash = '';
    link.href = target.toString();
  };
  const refreshLinks = () => document.querySelectorAll('[data-pc-tag-link]').forEach(preserveQuery);
  refreshLinks();
  ['pointerdown', 'click', 'focusin'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const link = event.target.closest('[data-pc-tag-link]');
      if (link) preserveQuery(link);
    });
  });
  window.addEventListener('pageshow', refreshLinks);
  window.addEventListener('popstate', refreshLinks);
  document.addEventListener('shopify:section:load', refreshLinks);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.pc-brand-facets');
    if (!form) return;
    event.preventDefault();
    const url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach((key) => {
      if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
    });
    const fields = new FormData(form);
    const fieldNames = new Set(fields.keys());
    fieldNames.forEach((key) => url.searchParams.delete(key));
    fields.forEach((value, key) => {
      if (value !== '') url.searchParams.append(key, value);
    });
    url.hash = new URL(form.action).hash;
    window.location.assign(url.toString());
  });
})();
